import * as TX from "app/calcs/Accountant/Transactions/interfaces"
import {
    ILocal145PensionInputs,
    Local145FormOfPayment,
} from "app/calcs/customers/local145/interfaces"
import { CommonPensionCalculations } from "app/calcs/pensions"
import {
    IMonthlyPensionPayments,
    SimplePensionFormOfPayment,
} from "app/calcs/pensions/interfaces"
import { cachedLocal145RunCalculations } from "app/redux/Customers/local145/actions"
import {
    IRetirementPerson,
    isValidPerson,
    Profile,
} from "app/redux/Profile/model"
import { WorkbookServiceResponse } from "app/redux/SSA/actions"
import {
    makeMiscExtractor,
    makePaymentExtractor,
} from "app/workbookDAOs/local145DAO"
import * as _ from "lodash"
import * as moment from "moment"

class Local145PensionCalculations extends CommonPensionCalculations<ILocal145PensionInputs> {
    private spouse: IRetirementPerson

    constructor(profile: Profile, name: string = "Local 145") {
        super(profile, name, "beginPaymentsAge")
    }

    getMonthlyPensionAmount(
        member: IRetirementPerson,
        vals: ILocal145PensionInputs,
        when: moment.Moment
    ): Promise<IMonthlyPensionPayments> {
        const spouse = this.spouse
        const shared = this.profile.pension.shared
        vals.formOfPayment = this.profile.pension.local145.formOfPayment
        const extractPayment = makePaymentExtractor(vals, when)
        const extractInfo = makeMiscExtractor()
        let totalLumpSum = 0
        let totalVestingService = 0
        let totalPensionCredits = 0
        const ioInputs = this.profile.pension.IO
        const nebfInputs = this.profile.pension.NEBF
        return cachedLocal145RunCalculations({
            member,
            spouse,
            vals,
            ioInputs,
            nebfInputs,
            shared,
            when: null,
        })
            .then((wr: WorkbookServiceResponse) => {
                const info = extractInfo(wr)
                totalLumpSum = info.totalLumpSum
                totalPensionCredits = info.totalPensionCredits
                totalVestingService = info.totalVestingService
                return extractPayment(wr)
            })
            .then((baseAmount) => {
                const kind = vals.formOfPayment as SimplePensionFormOfPayment
                const z = this.calculateSimplePension(
                    when,
                    baseAmount,
                    kind,
                    false
                )
                z.totalLumpSum = totalLumpSum
                z.totalVestingService = totalVestingService
                z.totalPensionCredits = totalPensionCredits
                return z
            })
    }

    getPension(): ILocal145PensionInputs {
        return this.profile.pension.local145
    }

    getPerson(): IRetirementPerson {
        return this.profile.getHeadOfHousehold()
    }

    getTimeLineTransactions(): Promise<TX.ITransactionItem[]> {
        this.setSpouse(this.profile.getSpouse())
        return super.getTimeLineTransactions()
    }

    getTransactions(
        when: moment.Moment,
        tolerance: TX.TransactionTolerance = "month"
    ): Promise<TX.ITransactionItem[]> {
        this.setSpouse(this.profile.getSpouse())
        return super.getTransactions(when, tolerance)
    }

    setSpouse(spouse: IRetirementPerson) {
        this.spouse = spouse
    }
}

export { Local145PensionCalculations }



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local145/index.ts